import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ButtonStyle } from 'app/shared/enums';

@Component({
  selector: 'app-details-header',
  imports: [CommonModule, MatIcon],
  templateUrl: './details-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsHeaderComponent {
  @Output() public goBack = new EventEmitter<boolean>();
  protected readonly ButtonStyle = ButtonStyle;
}
